/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Toolkit_PlatformsInputs */

const en_pc_alt_t_toolkit_platforms = /** @type {(inputs: Pc_Alt_T_Toolkit_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any modern browser`)
};

const zh_pc_alt_t_toolkit_platforms = /** @type {(inputs: Pc_Alt_T_Toolkit_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任何现代浏览器`)
};

/**
* | output |
* | --- |
* | "Any modern browser" |
*
* @param {Pc_Alt_T_Toolkit_PlatformsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_toolkit_platforms = /** @type {((inputs?: Pc_Alt_T_Toolkit_PlatformsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Toolkit_PlatformsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_toolkit_platforms(inputs)
	return zh_pc_alt_t_toolkit_platforms(inputs)
});
export { pc_alt_t_toolkit_platforms as "pc.alt.t.toolkit.platforms" }